export default {
  tip:
    'Facebook will enable its plugin for whitelisted domains that you add via this form.' +
    ' To see a list of domains you\'ve added to your whitelist, go to your "Messenger" settings in ' +
    " your Business's Facebook page",
  domain_exists: 'This domain already exists',
  incorrect_error: 'Incorrect URL',
};
